import { media } from './media.js';
import { breakpoints } from '../theme/breakpoints.js';

/**
 * Maps breakpoints and their respective values to CSS media queries
 * @param {string|object} values Input value, optionally for a given breakpoint (e.g. 'primary10' or {m: 'primary10'})
 * @param {Function} map Function that takes input value as argument and returns CSS expression
 * @returns {string} CSS media queries for each requested breakpoint
 */
const mapToBreakpoints = (values, map) => {
  const returnValues = [];
  if (values === null || typeof values !== 'object') {
    return map(values);
  }
  for (const key of Object.keys(values)) {
    if (!breakpoints[key]) continue;
    // @ts-ignore
    const mappedValues = map(values[key]);
    // @ts-ignore
    returnValues.push(media.greaterThan(key)`
      ${mappedValues}
    `);
  }
  return returnValues;
};

export { mapToBreakpoints };
//# sourceMappingURL=mapToBreakpoints.js.map
